import { DataVariableType } from '@empathy/global/data';

import { DataVariableOptions } from './data-variable-option.model';

export class DataVariable {
  id: string;
  typeId: DataVariableType;
  dataVariableKeyName: string;
  groupId: number;
  options: DataVariableOptions[];
  useAsSurveyResultFilterInd: boolean;
}
